module.exports = __webpack_public_path__ + "img/credential-text-niice.90945393c12383e39b06494772341620.svg";